import React, { Component } from "react";
import "moment-timezone";

import LeadsService from '../utils/LeadsService'

import { Formik, Form } from "formik";
import * as Yup from "yup";
import Alert from 'react-s-alert';

import FormikTextAreaControl from "../Shared/Forms/FormikTextAreaControl";

import { Modal, Button } from 'react-bootstrap'

class AddNoteModal extends Component {
  render() {
    const { showModal, onCloseModal } = this.props
    const validationSchema = Yup.object().shape({
      notes: Yup.string().max(1000, "maximum 1000 characters")
    });
    return (
      <Modal show={showModal} onHide={onCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Add Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{ notes: '' }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              const { onConfirmModal } = this.props
              const { lead } = this.props
              LeadsService.takeAction('add_note', lead.id, values).then(data => {
                Alert.success('Added')
                onConfirmModal(data)
              });
            }}
            render={({
              errors,
              touched,
              isValid,
              isSubmitting,
            }) => (
                <Form>

                  <FormikTextAreaControl fieldLabel='Add Notes' fieldName='notes' errors={errors} touched={touched} textareaHeight={200} />

                  <div style={{ marginTop: 20 }}>
                    <Button onClick={onCloseModal} bsSize='small'>Whoops, cancel this</Button>
                    <Button className='pull-right' disabled={!isValid || isSubmitting} type="submit" bsStyle='success' bsSize='small'>Add a Note</Button>
                  </div>
                </Form>
              )} />
        </Modal.Body>
      </Modal>)
  }
}

export default AddNoteModal